module.exports = __webpack_public_path__ + "static/media/icon-box1.3e303a8a.svg";